import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';

var TariffStatement = function (_super) {
  __extends(TariffStatement, _super);

  function TariffStatement() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.tariffStatementSearchEnum = [];
    _this.flowTypeList = [];
    _this.chargeTypeList = [];
    _this.dataList = [];
    _this.loadingStatus = false;
    _this.esPoint = null;
    _this.columns = [];
    _this.rowSelection = {};
    _this.accountList = [];
    _this.selectedList = [];
    _this.selectedPendingConfirmList = [];
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition(31);
    _this.currencyList = [];
    _this.costTypeList = [];
    _this.searchData = {};
    _this.lastParams = {};
    _this.total = 0;
    return _this;
  }

  TariffStatement.prototype.onDatetimeDefaultValueChange = function (arr) {
    this.getSearchDataDateTime(arr);
  };

  TariffStatement.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('账户编码'),
      dataIndex: 'account_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('流水单号'),
      dataIndex: 'serial_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('参考号'),
      dataIndex: 'order_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('业务类型'),
      dataIndex: 'business_type_text',
      filterEmpty: true
    }, {
      title: this.t('费用类型'),
      dataIndex: 'fee_type_text'
    }, {
      title: this.t('流水类型'),
      dataIndex: 'flow_type_text',
      filterEmpty: true
    }, {
      title: this.t('账单状态'),
      dataIndex: 'charge_type_text',
      filterEmpty: true
    }, {
      title: this.t('金额'),
      align: 'right',
      scopedSlots: {
        customRender: 'amount'
      }
    }, {
      title: this.t('账户余额'),
      align: 'right',
      scopedSlots: {
        customRender: 'currency_balance_text'
      }
    }, {
      title: this.t('币种'),
      dataIndex: 'currency_code',
      filterEmpty: true
    }, {
      title: this.t('费用发生时间'),
      dataIndex: 'transaction_time',
      filterEmpty: true
    }];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys, selectedRows) {
        _this.rowSelection.selectedRowKeys = _this.selectedList = selectedRowKeys;
        var pendingConfirmList = [];
      }
    };
    this.searchData = this.getInitSearchData();
    this.getSearchDataDateTime(this.datetimeDefaultValue);
    this.queryTariffStatementList();
    this.queryAccountList();
    this.queryCurrencyList();
  };

  TariffStatement.prototype.queryTariffStatementList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.lastParams = this.$util.deepCopy(this.searchData);
            return [4, this.$api.finance.queryTariffStatementList(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  TariffStatement.prototype.queryCurrencyList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryCurrencyList()];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.currencyList = data;
            return [2];
        }
      });
    });
  };

  TariffStatement.prototype.queryAccountList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryAccountList()];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.accountList = data.map(function (item) {
              return __assign(__assign({}, item), {
                sign_business_list_text: item.sign_business_list.map(function (it) {
                  return it.key;
                }).join(',')
              });
            });
            return [2];
        }
      });
    });
  };

  TariffStatement.prototype.getSearchDataDateTime = function (arr) {
    if (arr.length) {
      this.searchData.begin_time = this.$util.formatDateTime(arr[0]);
      this.searchData.end_time = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.begin_time = '';
      this.searchData.end_time = '';
    }
  };

  TariffStatement.prototype.getInitSearchData = function () {
    return {
      page_index: 1,
      page_size: 10,
      fee_type: undefined,
      flow_type: undefined,
      order_number: undefined,
      reference_number: undefined,
      account_code: undefined,
      begin_time: undefined,
      end_time: undefined,
      currency_code: undefined,
      billing_status: undefined,
      number_type: this.$enum.finance.CostStatementSearchEnum.ORDER_NUMBER
    };
  };

  TariffStatement.prototype.handlePageChange = function (page) {
    this.initPage();
    this.searchData.page_index = page;
    this.queryTariffStatementList();
  };

  TariffStatement.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryTariffStatementList();
  };

  TariffStatement.prototype.initPage = function () {
    this.searchData.page_index = 1;
    this.selectedList = [];
    this.selectedPendingConfirmList = [];
    this.rowSelection.selectedRowKeys = [];
  };

  TariffStatement.prototype.handleSearch = function () {
    this.initPage();
    this.queryTariffStatementList();
  };

  TariffStatement.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition(31);
    this.$nextTick(function () {
      return _this.queryTariffStatementList();
    });
  };

  TariffStatement.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};
            postData = __assign({}, this.lastParams);
            delete postData.page_index;
            delete postData.page_size;

            if (isAll) {
              postData["export"] = 1;
              postData.id_list = [];
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData["export"] = 2;
              postData.id_list = this.selectedList;
            }

            return [4, this.$api.finance.exportTariffStatement(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  __decorate([enumData('Finance/TariffStatementSearchEnum')], TariffStatement.prototype, "tariffStatementSearchEnum", void 0);

  __decorate([enumData('Finance/TariffFlowTypeEnum')], TariffStatement.prototype, "flowTypeList", void 0);

  __decorate([enumData('Finance/BillingStatusEnum')], TariffStatement.prototype, "chargeTypeList", void 0);

  __decorate([enumData('Finance/TariffFlowFeeTypeEnum')], TariffStatement.prototype, "costTypeList", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], TariffStatement.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([loading('loadingStatus')], TariffStatement.prototype, "queryTariffStatementList", null);

  __decorate([userPrefPageSize('tariffStatementList')], TariffStatement.prototype, "getInitSearchData", null);

  TariffStatement = __decorate([Component], TariffStatement);
  return TariffStatement;
}(Vue);

export default TariffStatement;